<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"
export default {
	name: "CBProposalSumInsured",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>20. For what amount is Policy required?</div>"
					},
					bindTo: ""
				},
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>(a) On stock (including goods in trust)</div>"
					},
					bindTo: ""
				},
				{
					label: "(a) (1) Swallow's Nest",
					component: "number",
					dataType: "number",
					bindTo: "case.facts.swallowsNestSumInsured"
				},
				{
					label: "(a) (2) Wine and Spirits",
					component: "number",
					dataType: "number",
					bindTo: "case.facts.wineAndSpiritsSumInsured"
				},
				{
					label: "(a) (3) Preserved seafood, pharmacy",
					component: "number",
					dataType: "number",
					bindTo: "case.facts.preservedSeafoodAndPharmacySumInsured"
				},
				{
					label: "(a) (4) Household Sundry Goods",
					component: "number",
					dataType: "number",
					bindTo: "case.facts.sundryGoodsSumInsured"
				},
				{
					label: "(a) (5) Cigar, Cigarette and Tobacco, Pipe and related goods",
					component: "number",
					dataType: "number",
					bindTo: "case.facts.cigaretteAndRelatedGoods"
				},
				{
					component: "html",
					props: {
						content: "<div class='fs4 fw7 lh125'>(b) Cash and Bank Notes</div>"
					},
					bindTo: ""
				},
				{
					label: "(b) at counter",
					component: "number",
					dataType: "number",
					bindTo: "case.facts.cashAndBankNotesAtCounter"
				},
				{
					label: "(b) at locked safe",
					component: "number",
					dataType: "number",
					bindTo: "case.facts.cashAndBankNotesAtLockedSafe"
				},
				{
					label:
						"(c) On Trade and Office Furniture, Fixtures and Fittings, Machinery, Plant, Safes, Alarm Systems, Tenants' decorations and improvements, and all other Contents (except your stock and goods in trust) at your premises against the risks of Fire, Lightning, Explosion, Aircraft, Burglary or Theft or any attempt thereat, Storm, Tempest, Flood or Bursting or Overflowing or Leakage of Water Pipes or Apparatus, or Impact by any road vehicle, not belonging to or under your control.",
					component: "number",
					dataType: "number",
					bindTo: "case.facts.tradeAndOfficeFurnitureFixturesFittings"
				}
			]
		}
	}
}
</script>
